import { createStyles, makeStyles } from '@material-ui/styles';
import { grey } from '../../../../../theme/colors';

const style = () =>
  createStyles({
    headintro: {
      display: 'flex',
      gap: '5px',
      flexWrap: 'wrap',
      fontWeight: 600,
      fontSize: '1.5rem'
    },
    actionboxintro: {
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'center',
      gap: '7px'
    },
    dashblock: {
      border: '1px dashed #000000',
      padding: '10px',
      borderRadius: '10px',
      width: '100%',
      maxWidth: '375px',
      display: 'flex',
      flexDirection: 'column',
      marginLeft: 'auto',
      marginRight: 'auto',
      transition: 'ease-out all 0.3s .1s',
      '&:hover': {
        paddingRight: '20px',
        paddingLeft: '20px',
        maxWidth: '395px'
      }
    },
    modalContent: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '10px',
      padding: '20px'
    },
    modalList: {
      width: '90%'
    },
    textContrast: {
      color: grey.dark
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
